<template>
  <div>
    <p class="report__overview-detail-title">{{ title }}</p>
    <p class="report__overview-detail-description">{{ description }}</p>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    description: [String, Number],
  },
};
</script>
<style>
.report__overview-detail-title {
  margin-bottom: 0px;
  text-transform: uppercase;
  font-weight: 700;
  color: black;
  font-family: "DM Sans" !important;
}
.report__overview-detail-description {
  margin-bottom: 0px;
  font-weight: 500;
  color: black;
  font-family: "DM Sans" !important;
}
</style>
